import { Link } from 'react-router';
import { useI18n } from '@/i18n/i18n-provider';
import { EmptyState } from '@/components/ui';

export function NotFoundPage() {
  const { t } = useI18n();

  return (
    <div className="page">
      <EmptyState title={t('common.states.noResults')} />
      <p style={{ textAlign: 'center' }}>
        <Link to="/people">{t('navigation.people')}</Link>
      </p>
    </div>
  );
}
